/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-09-01 21:20:48
 * @LastEditors: Betway
 * @LastEditTime: 2026-08-25 09:43:07
 * @FilePath: \mrc-base-server-view\src\service\baseUrl.js
 */
/**
 * 是否本地開發環境
 * 判斷是否開啓代理
 */
const isLocal = () => location.host.includes("localhost")

// const Url = process.env.VUE_APP_BASE_URL //独立版本部署打开这个，打包完之后关闭
const Url = isLocal() ? process.env.VUE_APP_BASE_URL : businessUrl
const baseUrl = `${Url}/mrcbase`
export default baseUrl
